<section id="two-column" class="component component--two-column two-column bg-color-white text-color-dark">
	<div class="wrapper">
		<div class="row text-center">
			<div class="col-12 col-sm-6" *ngIf="inquiryData.left_block != ''">
				<h3 *ngIf="inquiryData.left_block.li_heading != ''" [innerHtml]="inquiryData.left_block.li_heading"></h3>
				<p *ngIf="inquiryData.left_block.li_email != ''"><a href="mailto: {{ inquiryData.left_block.li_email }}">{{ inquiryData.left_block.li_email }}</a></p>
			</div>
			<div class="col-12 col-sm-6" *ngIf="inquiryData.right_block != ''">
				<h3 *ngIf="inquiryData.right_block.ri_heading != ''" [innerHtml]="inquiryData.right_block.ri_heading"></h3>
				<p *ngIf="inquiryData.right_block.ri_email != ''"><a href="mailto: {{ inquiryData.right_block.ri_email }}">{{ inquiryData.right_block.ri_email }}</a></p>
			</div>
		</div>
	</div>
</section>